import AboutCoreServices from './about-core-services';

export default AboutCoreServices;